import { Expose } from 'class-transformer';
import type { IRepayOrder, REPAYABLE_TYPE } from './repayment.interface';

export class RepaymentModel {
  // 所有可还款金额 = 逾期部分总金额 + DOB 10+部分总金额
  @Expose()
  total_amount!: number;

  @Expose()
  overflow_amount!: number;

  @Expose()
  overdueInfo!: IRepayOrder;

  @Expose()
  repayableInfo!: IRepayOrder;

  @Expose()
  selectedChannelName!: string;

  @Expose()
  selectedChannelId!: number;

  @Expose()
  payOption!: string;

  @Expose()
  loading!: boolean;

  // 后端实时算出的、本次允许提交的 type 集合。哪个 type 不在集合里，对应那组就不允许勾选
  @Expose()
  allowed_repayable_types!: REPAYABLE_TYPE[];

  // 单笔主动还款最多绑定的计划数(M)
  @Expose()
  batch_limit!: number;

  // 可还款计划总数，与 batch_limit 比较判断本次是否只能还一批
  @Expose()
  total_count!: number;
}
